import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Segment, Divider, Header } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikConfirmedPasswordInput from "../forms/formik/FormikConfirmedPasswordInput.jsx";
import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

import accountSelectors from "../../state/reducers/account/accountSelectors.js";

class SecurityForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    renderMessage: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,
    passwordUpdateAvailability: PropTypes.bool.isRequired,
    copyKey: PropTypes.string,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "account.security"
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      password: "",
      passwordConfirmation: "",
      oldPassword: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      password: Schemas.passwordSchema("Password", messages, true),
      passwordConfirmation: Schemas.passwordConfirmationSchema(
        "Password confirmation",
        messages,
        true
      ),
      oldPassword: Schemas.requiredString("Old Password", messages, true)
    });
  };

  // -- RENDER -- //

  render() {
    const {
      onReset,
      onSubmit,
      onFormikSubmit,
      renderMessage,
      violationErrors,
      passwordUpdateAvailability,
      copyKey,
      copy
    } = this.props;

    if (passwordUpdateAvailability === true) {
      return (
        <Formik
          initialValues={this.initialValues} // required by semantic-ui react
          validateOnMount={true}
          validationSchema={this.validationSchema()}
          onSubmit={onFormikSubmit}
        >
          {formikProps => {
            return (
              <Segment vertical padded textAlign="left">
                <Form className="ui form">
                  {renderMessage(formikProps)}

                  <Header as="h3">{copy(`${copyKey}.title`)}</Header>
                  <p>{copy(`${copyKey}.body`)}</p>

                  <FormikConfirmedPasswordInput apiErrors={violationErrors} />

                  <Divider section />

                  <p>
                    {copy(
                      `${copyKey}.confirmed_password_input.confirm_old_body`
                    )}
                  </p>
                  <Field
                    name="oldPassword"
                    placeholder={copy(
                      `${copyKey}.confirmed_password_input.confirm_old_placeholder`
                    )}
                    label={copy(
                      `${copyKey}.confirmed_password_input.confirm_old_label`
                    )}
                    type={"password"}
                    required={true}
                    fluid
                    apiErrors={violationErrors}
                    component={FormikSemanticInput}
                  />

                  <FormikActionsPanel
                    reset={true}
                    onReset={onReset}
                    submit={true}
                    useSubmitModal={true}
                    onSubmit={onSubmit}
                    modalCopy={copy(`account.modals`)}
                  />
                </Form>
              </Segment>
            );
          }}
        </Formik>
      );
    }

    return (
      <Segment vertical padded textAlign="left">
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <SegmentMessage
          info={true}
          message={copy(`${copyKey}.password_disabled`)}
        />
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  passwordUpdateAvailability:
    accountSelectors.selectPasswordUpdateAvailability(state)
});

export default connect(mapStateToProps)(SecurityForm);
